import * as React from 'react'
function SvgCurrencyEuro(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M29.6 28.4C27.8 29.4 26 30 24 30c-4 0-7.6-2.4-9.2-6H22c1.2 0 2-.8 2-2s-.8-2-2-2h-8c0-.6 0-1.4.2-2H22c1.2 0 2-.8 2-2s-.8-2-2-2h-6c1.8-2.4 4.6-4 8-4 2 0 3.8.6 5.6 1.6 1 .6 2.2.4 2.8-.6.6-1 .4-2.2-.6-2.8C29.4 6.8 26.8 6 24 6c-5.6 0-10.4 3.2-12.6 8H8c-1.2 0-2 .8-2 2s.8 2 2 2h2.2c-.2.6-.2 1.4-.2 2H8c-1.2 0-2 .8-2 2s.8 2 2 2h2.6c1.8 5.8 7 10 13.4 10 2.8 0 5.4-.8 7.8-2.4 1-.6 1.2-1.8.6-2.8-.8-.8-2-1-2.8-.4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCurrencyEuro
